import { AxiosRequestConfig, AxiosResponse } from 'axios';

import { request } from './request';

export const put = <T, R = AxiosResponse<T>, D = unknown>(
  url: string,
  data?: D,
  config?: AxiosRequestConfig<D>,
) => request<T, R>({ method: 'put', url, data, ...config });
